import React from 'react';

const PaymentInfo = () => {
  return <div>Payment Info</div>;
};

export default PaymentInfo;
